import { HttpClient } from '@wix/http-client';
import { InitialParams } from '@wix/wix-chatbot-common/browser';

import { renderModel } from '../util/renderModel';

const { queryParams } = renderModel.get();

export const STATUS = {
  OK: 200,
  CONFLICT: 409,
};

const headers: { [key: string]: any } = {
  'Content-Type': 'application/json',
};

const [artifact, wdpId] = queryParams['x-wix-route']
  ? (queryParams['x-wix-route'] as string).split(':')
  : [];
if (artifact && wdpId) {
  headers[`x-wix-route-${artifact}`] = wdpId;
}

function validateStatus(status: number) {
  return status === STATUS.OK || status === STATUS.CONFLICT;
}

export const baseURL =
  window.location.origin + (window.__BASEURL__ || '').replace(/\/$/, '');

let httpClientInstance: HttpClient;

export type HttpClientFactory = {
  getInstance: (params?: InitialParams) => HttpClient;
};

export const httpClient: HttpClientFactory = {
  getInstance: ({ authToken }: InitialParams = { authToken: '' }) => {
    if (!httpClientInstance) {
      httpClientInstance = new HttpClient({
        baseURL,
        validateStatus,
        headers,
        getAppToken: () => authToken,
      });
    }
    return httpClientInstance;
  },
};
